const Company = {

    // FIELDS
    "name": "الاسم",
    "address": "العنوان",
    "postal_code": "الرمز البريدي",
    "website": "الموقع الإلكتروني",
    "email": "البريد الإلكتروني",
    "telephone": "رقم الهاتف",
    "mobile_no": "رقم الجوال",
    "fax": "الفاكس",
    "logo": "الشعار",
    "type_of_company": "نوع الشركة",
    "pan_no": "رقم البطاقة الشخصية",
    "state": "الولاية",
    "city": "المدينة",
    "country": "البلد",
    "search": "بحث",

    // PAGE HEADER
    "company": "الشركة",

    // ERROR
    "error_name": "أدخل الاسم",
    "error_address": "أدخل العنوان",
    "error_postal_code": "أدخل الرمز البريدي",
    "error_website": "الرابط مطلوب",
    "error_email": "أدخل البريد الإلكتروني",
    "error_telephone": "أدخل رقم الهاتف",
    "error_mobile_no": "أدخل رقم الجوال",
    "error_fax": "أدخل الفاكس",
    "error_logo": "الشعار مطلوب",
    "error_type_of_company": "أدخل نوع الشركة",
    "error_pan_no": "أدخل رقم البطاقة الشخصية",
    "error_country": "اختر البلد",
    "error_state": "اختر الولاية",
    "error_city": "اختر المدينة",
    "error_min": "يجب أن يتكون من 10 أرقام",
    "error_max": "يجب أن يتكون من 15 رقمًا",
    "error_matches_pan": "رقم بطاقة شخصية غير صالح",

    // TABLE HEADER
    "table_name": 'الاسم',
    "table_city": "المدينة",
    "table_mobile_no": "الجوال",

}

export default Company;